module.exports = __webpack_public_path__ + "img/quem-somos-bloco-3.345385f5.jpg";